/** Customer-facing copy for policy-system (Entsia) outage scenarios. */

import type { PolicySystemSnapshot, PolicySystemStatus } from '../services/types';

export type { PolicySystemSnapshot, PolicySystemStatus };

/** Frontend policy-system state (health snapshot plus optional request correlation). */
export type PolicySystemState = PolicySystemSnapshot & {
  correlationId?: string;
};

export const POLICY_SYSTEM_UNAVAILABLE_CODE = 'POLICY_SYSTEM_UNAVAILABLE';

export const policySystemMessages = {
  banner:
    "We're having trouble connecting to our policy system. What you see may not be up to date. Policy changes and new claims can't be submitted online right now.",
  pageTitle: 'Online policy services are temporarily unavailable',
  pageBody:
    "We're unable to connect to our policy system right now. Your insurance cover is not affected — this only affects viewing and managing your policy online.",
  pageBulletCover: 'Your cover continues — this issue only affects the online portal.',
  pageBulletUrgentClaim:
    'Urgent claim or accident? Call 1300 296 296 — our claims team can help immediately.',
  pageBulletPolicyChange: 'Need to change policy details? Call 1300 296 296 or try again later.',
  pageBulletLinkPolicy: 'Linking a new policy? Try again when services restore, or call us.',
  writeBlocked:
    "We can't complete this online while our policy system is unavailable. Please call 1300 296 296 or try again later.",
  linkPolicy:
    "We can't link policies online while our policy system is unavailable. Please try again later or call 1300 296 296.",
  claims:
    "We can't submit your claim online right now. For accidents and urgent claims, call 1300 296 296 — our claims team can lodge your claim for you.",
  tryAgain: 'Try again',
  referenceLabel: 'Reference',
  supportPhone: '1300 296 296',
  supportPhoneHref: 'tel:1300296296',
} as const;
